import React, { useState, useEffect } from 'react';

import { Dialog, Card } from '@mui/material';
import { images, icons, MAIL_FORMATTING } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import Button from '../Buttons/Button';
import { useIsMobile } from '../../helpers/customHooks';
import NewButton from '../Buttons/NewButton';
import toast from 'react-hot-toast';


const MassShareModal = ({show, onClose, selectedDevices = [], onSave}) => {
    const MOBILE = useIsMobile();
    const { t } = useTranslation();
    const [email, setEmail] = useState("")
    const [addedEmails, setAddedEmails] = useState([])
    const [removedEmails, setRemovedEmails] = useState([]); // 👈 new state

    const [invalidEmail, setInvalidEmail] = useState(false)
    const [type, setType] = useState("")

    useEffect(() => {
        if(!show){
            setAddedEmails([])
            setRemovedEmails([])
        }
    },[show])

    useEffect(() => {
        if(selectedDevices?.length > 1){
            setType("multiple")
        }else{
            setType("single")
        }
    }, [selectedDevices])


    const handleChange = (type, e) => {
        switch(type){
            case "email":
                setEmail(e.target.value)
            break;
            default: return
        }
        setInvalidEmail(false)
    }

    const handleClose = () => {
        onClose()

      //  setShow(false)
    }

    const handleSave = (arrays) => {
        onSave(arrays)
    }

    const removeEmails = (emailToRemove) => {
        const devBoy = selectedDevices[0];
        const sharedWith = devBoy?.shared?.sharedwith?.map(e => e.email) || [];

        // Check if the email exists in sharedWith
        if (sharedWith.includes(emailToRemove)) {
            // Add it to removeArray if not already there
            setRemovedEmails(prev =>
                prev.includes(emailToRemove)
                    ? prev
                    : [...prev, emailToRemove]
            );
        }

        // Remove from addedEmails if it's a newly added email
        setAddedEmails(prev => prev.filter(email => email !== emailToRemove));
    };

    

    const addEmails = () => {
        const devBoy = selectedDevices[0];
        const sharedWith = devBoy?.shared?.sharedwith?.map(e => e.email) || [];

        // Filter out emails marked as removed
        const visibleShared = sharedWith.filter(email => !removedEmails?.includes(email));

        // Combine visible shared + newly added
        const combinedEmails = [
            ...visibleShared,
            ...addedEmails
        ];

        return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        <h3 className="ms-2">{t("events.add_emails")}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
                </div>
                <p className="grey-blue py-3">{t("events.add_emails_sub", {device: devBoy?.devicename})}</p>
                <div className={`d-flex flex-column rounded24 px-2 py-3 bg-light-grey ${combinedEmails?.length === 0 ? "d-none" : ""} mb-3`}>
                    {combinedEmails?.map((email, index) => (
                        <div key={index} className={`d-flex justify-content-between align-items-center bg-grey-blue white p-2 rounded12 ${index !== combinedEmails?.length - 1 ? "mb-2" : ""}`}>
                            <p className="white">{email}</p>
                            <NewButton notext={true} className="ful-rounded bg-light-grey p-1" icon={icons.close} iconClass={"dark-grey-icon size_12"} onClick={() => removeEmails(email)}/>
                        </div>
                    ))}
                </div>
                <form>
                    <div className="form-group d-flex align-items-center">
                        <input
                            type="text"
                            className="form-control rounded24 p-3 bg-light-grey grey-blue"
                            id="email"
                            value={email}
                            onChange={(e) => {
                                handleChange("email", e);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                if(!MAIL_FORMATTING.test(e.target.value) || addedEmails.includes((e.target.value))){
                                        toast.error(t("settings.error_adding_email"))
                                }else{
                                    const newAddedEmails = [...addedEmails, e.target.value];
                                    setAddedEmails(newAddedEmails); // Update the state with the new array
                                    setEmail("")
                                }
                                e.preventDefault();// Prevent the default Enter key behavior
                                
                                }
                            }}
                        />
                    </div>
                </form>

                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
					<NewButton onClick={handleClose} className="bg-grey p-3 rounded24 w-50 me-2 dark-grey ms-auto body bold">
						{t("settings.close")}
					</NewButton>
                    <NewButton 
                        onClick={() => handleSave({ added: addedEmails, removed: removedEmails })} 
                        className="bg-gradient p-3 rounded24 w-50 white ms-2 body bold">
                        {t("settings.save")}
                    </NewButton>
				</div>
            </div>
        )
    }

    const addEmailsMass = () => {
        return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        <h3 className="ms-2">{t("events.add_emails")}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
                </div>
                <p className="grey-blue py-3">{t("events.add_emails_mass_sub1")}</p>
                <div className="d-flex flex-column mb-3">
                    {selectedDevices?.map((device, index) => (
                        <p key={index} className="grey-blue bold text-start">{device.devicename}</p>
                    ))}
                </div>
                <div className={`d-flex flex-column rounded24 px-2 py-3 bg-light-grey ${addedEmails?.length === 0 ? "d-none" : ""} mb-3`}>
                    {addedEmails?.map((email, index) => (
                        <div key={index} className={`d-flex justify-content-between align-items-center bg-grey-blue white p-2 rounded12 ${index !== addedEmails?.length - 1 ? "mb-2" : ""}`}>
                            <p className="white">{email}</p>
                            <NewButton notext={true} className="ful-rounded bg-light-grey p-1" icon={icons.close} iconClass={"dark-grey-icon size_12"} onClick={() => removeEmails(email)}/>
                        </div>
                    ))}
                </div>
                <form>
                    <div className="form-group d-flex align-items-center">
                        <input
                            type="text"
                            className="form-control rounded24 p-3 bg-light-grey grey-blue"
                            id="email"
                            value={email}
                            onChange={(e) => {
                                handleChange("email", e);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                if(!MAIL_FORMATTING.test(e.target.value) || addedEmails.includes((e.target.value))){
                                        toast.error(t("settings.error_adding_email"))
                                }else{
                                    const newAddedEmails = [...addedEmails, e.target.value];
                                    setAddedEmails(newAddedEmails); // Update the state with the new array
                                    setEmail("")
                                }
                                e.preventDefault();// Prevent the default Enter key behavior
                                
                                }
                            }}
                        />
                    </div>
                </form>
                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
					<NewButton onClick={handleClose} className="bg-grey p-3 rounded24 w-50 me-2 dark-grey ms-auto body bold">
						{t("settings.close")}
					</NewButton>
                    <NewButton 
                        onClick={() => handleSave({ added: addedEmails, removed: removedEmails })} 
                        className="bg-gradient p-3 rounded24 w-50 white ms-2 body bold">
                        {t("settings.save")}
                    </NewButton>
				</div>
            </div>
        )
    }

    const typeRender = () => {
        switch(type){
            case "single": return addEmails()
            case "multiple": return addEmailsMass()
            default: return null
        }
    }

    return(
        <>
        <Dialog fullWidth={MOBILE ? true : false} open={show ?? false} onClose={handleClose}>
            <Card className="settings-dialog d-flex flex-column">
                <div className="w-100 h-100">
                    {typeRender()}
                </div>
            </Card>
        </Dialog>
        </>
    )
}

export default MassShareModal;